import timezones from 'components/UserSettings/HRIS/common/TimezoneSelector/timezones';
import { Select } from '@bettercomp/ui-components';

type TimezoneSelectorProps = {
  value?: string;
  onChange: (value: string) => void;
  testId?: string;
  error?: string
}

const options = timezones.map((timezone) => ({ label: timezone.replaceAll('_', ' '), value: timezone }));

export function TimezoneSelector({
  value,
  onChange,
  testId,
  error,
}: TimezoneSelectorProps) {
  return (
    <Select
      label="Timezone"
      placeholder="Timezone"
      value={value}
      options={options}
      onChange={onChange}
      data-testid={testId}
      error={error}
      virtual
    />
  )
}
